var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGavel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    stroke: "#999999",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gavel"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.4167 9.1662L19.1844 15.966C19.9389 16.7177 19.9389 17.935 19.1844 18.6858C18.822 19.0463 18.3316 19.2486 17.8204 19.2486C17.3093 19.2486 16.8189 19.0463 16.4564 18.6858L9.66669 11.9162M12.4167 9.1662L8.75002 5.49953M12.4167 9.1662L12.875 9.62454L14.9769 7.52262C15.1488 7.35072 15.2453 7.1176 15.2453 6.87454C15.2453 6.63147 15.1488 6.39835 14.9769 6.22645L11.6898 2.93929C11.5179 2.76744 11.2848 2.6709 11.0417 2.6709C10.7986 2.6709 10.5655 2.76744 10.3936 2.93929L8.29169 5.0412L8.75002 5.49953M12.4167 9.1662L9.66669 11.9162M9.66669 11.9162L6.00002 8.24953M9.66669 11.9162L10.125 12.3745L8.02311 14.4765C7.85121 14.6483 7.61809 14.7448 7.37502 14.7448C7.13196 14.7448 6.89884 14.6483 6.72694 14.4765L3.43977 11.1893C3.26793 11.0174 3.17139 10.7843 3.17139 10.5412C3.17139 10.2981 3.26793 10.065 3.43977 9.89312L5.54169 7.7912L6.00002 8.24953M6.00002 8.24953L8.75002 5.49953M3.25002 19.2495H9.66669",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGavel);
export default __webpack_public_path__ + "static/media/gavel.3c8bd07dd312bb787621be26e0f8f163.svg";
export { ForwardRef as ReactComponent };